/**
 * SplitModelSetSlideTable - Unified Model Sets Table Component
 *
 * This component consolidates multiple ModelSetsTable implementations across the codebase
 * into a single, optimized solution that handles different data structures from various APIs.
 *
 * Features:
 * - Automatic data type detection and parsing
 * - Support for Premium Report, Performance Report, and Cases data structures
 * - Split table layout for multiple portfolio options
 * - Dynamic column generation based on data
 * - Responsive design with compact layouts
 * - Backward compatibility with existing props
 */

import SplitModelSetSlideTable from './SplitModelSetSlideTable';
export default SplitModelSetSlideTable;
export * from './types';
export * from './parsers/DataParser';
